var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-editor-container"},[_c('panel-group',{attrs:{"allData":_vm.allData}}),_vm._v(" "),_c('el-row',{staticStyle:{"background":"#fff","padding":"16px 16px 0","margin-bottom":"32px"}},[_c('line-chart',{attrs:{"chart-data":_vm.lineChartData}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-121258af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/data/index.vue
// module id = null
// module chunks = 